module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6QlZg"))).then(() => module.bundle.root('d0iPb'));